"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var styled_system_1 = require("styled-system");

var theme_get_1 = require("@styled-system/theme-get");

var menu_button_1 = require("@reach/menu-button");

var Body_component_1 = require("../typography/Body.component");

var MenuStyle = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :root {\n    --reach-menu-button: 1;\n  }\n\n  [data-reach-menu] {\n    position: absolute;\n    z-index: 5;\n  }\n"], ["\n  :root {\n    --reach-menu-button: 1;\n  }\n\n  [data-reach-menu] {\n    position: absolute;\n    z-index: 5;\n  }\n"])));

exports.Dropdown = function (props) {
  var children = props.children;
  return React.createElement(React.Fragment, null, React.createElement(MenuStyle, null), React.createElement(menu_button_1.Menu, null, children));
};

var Divider = React.forwardRef(function () {
  return null;
});
var ItemWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styled_system_1.space);
var Trigger = styled_components_1.default(menu_button_1.MenuButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  border: none;\n  padding: 0;\n  margin: 0;\n  text-decoration: none;\n  background: transparent;\n  color: unset;\n  font-family: unset;\n  font-size: unset;\n  cursor: pointer;\n  text-align: center;\n\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  &:hover,\n  &:focus {\n    background: transparent;\n  }\n\n  &:focus {\n    outline: none;\n    outline-offset: 0;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n"], ["\n  display: inline-block;\n  border: none;\n  padding: 0;\n  margin: 0;\n  text-decoration: none;\n  background: transparent;\n  color: unset;\n  font-family: unset;\n  font-size: unset;\n  cursor: pointer;\n  text-align: center;\n\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  &:hover,\n  &:focus {\n    background: transparent;\n  }\n\n  &:focus {\n    outline: none;\n    outline-offset: 0;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n"])));
var ItemInnerWrapper = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var Text = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: ", " ", ";\n"], ["\n  padding: ", " ", ";\n"])), theme_get_1.themeGet('space.xs'), theme_get_1.themeGet('space.md')); // This will style the 3rd library elements

var StyledMenuList = styled_components_1.default(menu_button_1.MenuList)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  &[data-reach-menu-list] {\n    overflow: hidden;\n    outline: none;\n    cursor: pointer;\n    background-color: ", ";\n    color: ", ";\n    border-radius: ", ";\n    min-width: ", ";\n    max-width: 300px;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    box-shadow: ", ";\n\n    & a {\n      font-size: ", ";\n      line-height: ", ";\n      color: ", ";\n      text-decoration: none;\n      display: block;\n    }\n\n    & .is-last-in-section {\n      border-bottom: ", " ", ";\n    }\n\n    ", "\n  }\n\n  [data-reach-menu-item] {\n    color: ", ";\n    padding: ", " ", ";\n\n    ", "\n  }\n\n  [data-reach-menu-item][data-selected] {\n    outline: none;\n    background: ", ";\n  }\n"], ["\n  &[data-reach-menu-list] {\n    overflow: hidden;\n    outline: none;\n    cursor: pointer;\n    background-color: ", ";\n    color: ", ";\n    border-radius: ", ";\n    min-width: ", ";\n    max-width: 300px;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    box-shadow: ", ";\n\n    & a {\n      font-size: ", ";\n      line-height: ", ";\n      color: ", ";\n      text-decoration: none;\n      display: block;\n    }\n\n    & .is-last-in-section {\n      border-bottom: ", " ", ";\n    }\n\n    ", "\n  }\n\n  [data-reach-menu-item] {\n    color: ", ";\n    padding: ", " ", ";\n\n    ", "\n  }\n\n  [data-reach-menu-item][data-selected] {\n    outline: none;\n    background: ", ";\n  }\n"])), theme_get_1.themeGet('colors.background.default'), theme_get_1.themeGet('colors.text.default'), theme_get_1.themeGet('radii.md'), theme_get_1.themeGet('space.layout.xxxl'), theme_get_1.themeGet('space.xxs'), theme_get_1.themeGet('space.xxs'), theme_get_1.themeGet('elevations.2'), theme_get_1.themeGet('fontSizes.body.sm'), theme_get_1.themeGet('lineHeights.body.sm'), theme_get_1.themeGet('colors.text.default'), theme_get_1.themeGet('borders.thin'), theme_get_1.themeGet('colors.border.light'), function (props) {
  return props.compact && "\n      padding-top: " + theme_get_1.themeGet('space.xs') + ";\n      padding-bottom: " + theme_get_1.themeGet('space.xs') + ";\n    ";
}, theme_get_1.themeGet('color.text.secondary'), theme_get_1.themeGet('space.xs'), theme_get_1.themeGet('space.md'), function (props) {
  return props.compact && "\n      padding-top: " + theme_get_1.themeGet('space.xxs') + ";\n      padding-bottom: " + theme_get_1.themeGet('space.xxs') + ";\n      ";
}, theme_get_1.themeGet('colors.background.lightest'));
var MyMenuItem = menu_button_1.MenuItem;
var MyMenuLink = menu_button_1.MenuLink;

var isActive = function isActive(child) {
  return Boolean(child.props.active);
};

var isDisabled = function isDisabled(child) {
  return Boolean(child.props.disabled);
};

var isDivider = function isDivider(child) {
  return child.type === Divider;
};

var isLink = function isLink(child) {
  return child.type === menu_button_1.MenuLink;
}; // We will remap the items to allow the current API with Divider and some of props.
// Checks for component children and tgheir props. If props is true, Cookbook component is injected
// instead of library component so the list item meets designers requests.


exports.getItems = function (children) {
  var items = [];
  React.Children.forEach(children, function (child, i) {
    var classNames = [];

    if (isDivider(child)) {
      var lastItem = items.pop();
      if (!lastItem) return;
      items.push(React.cloneElement(lastItem, {
        className: [lastItem.props.className, 'is-last-in-section'].join(' ')
      }));
      return;
    }

    if (isDisabled(child)) {
      items.push(React.createElement(ItemWrapper, {
        py: "xs",
        px: "md",
        key: i
      }, React.createElement(Body_component_1.Body, {
        as: ItemInnerWrapper,
        size: "sm",
        color: "disabled"
      }, child.props.children)));
      return;
    }

    items.push(React.cloneElement.apply(React, __spreadArrays([child, {
      className: classNames.join(' '),
      key: i
    }], isLink(child) ? [] : [React.createElement(Body_component_1.Body, {
      size: "sm",
      key: i,
      color: isActive(child) ? 'primary' : 'default'
    }, child.props.children)])));
  });
  return items;
};

var MyMenuList = function MyMenuList(_a) {
  var children = _a.children;
  return React.createElement(StyledMenuList, null, exports.getItems(children));
};

exports.Dropdown.Trigger = Trigger;
exports.Dropdown.MenuList = MyMenuList;
exports.Dropdown.Item = MyMenuItem;
exports.Dropdown.Link = MyMenuLink;
exports.Dropdown.Text = Text;
exports.Dropdown.Divider = Divider;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;